/*
 * This file is loaded after require.js loads.
 * You will typically use this script to set configuration options and then load the first application module.
 * This ensures a single entry point, since this script is loaded asynchronously.
 * Note: since the script is loaded asynchronously, you cannot assume that the load and execution of the script will finish prior to other scripts referenced later in the same page.
 */
(function(root, $, _) {
    function readSiteSettingsFromCookie() {
        var result = {};
        var siteSettingMatch;
        var siteSettingsCookie = (siteSettingMatch = new RegExp('(?:^|; )siteSettings=([^;]*)').exec(document.cookie)) ? (siteSettingMatch[1]) : null;
        if(siteSettingsCookie) {
            _.each(siteSettingsCookie.split('&'), function(val) {
                var splitValue = val.split('=');
                result[splitValue[0]] = splitValue[1];
            });
        }

        return result;
    };

    var languageId, enableFrontEndEditing;
    if(!root.globalSettings) {
        var siteSettings = readSiteSettingsFromCookie();
        languageId = siteSettings.languageId;
        enableFrontEndEditing = siteSettings.enableFrontEndEditing == 'true';
    } else {
        languageId = root.globalSettings.language;
        enableFrontEndEditing = root.globalSettings.enableFrontEndEditing;
    }

    // Require.js path mappings
    require.config({
        baseUrl: root.R + 'js',
        waitSeconds : 40,
        paths: {
            'startup': root.R + 'startup/js',
            'templates': root.R + 'templates/html',
            'handlebars': ['//cdn.jsdelivr.net/handlebarsjs/3.0.0/handlebars.min', 'handlebars.min'],
            'typeahead': 'typeahead/typeahead.jquery.min',
            'bloodhound': 'typeahead/bloodhound.min',
            'plupload': 'plupload-2.3.6/plupload.full.min'
        },
        shim: {
            plupload: {
                exports: 'plupload'
            }
        },
        config: {
            //Set the config for the i18n module ID
            i18n: {
                locale: languageId == 3 ? 'nb-no' : ''
            }
        },
        urlArgs: root.globalSettings && root.globalSettings.version ? 'v=' + root.globalSettings.version : false
    });

    if(typeof $ === 'function') {
        root.define('jquery', function () { return $; });

        $(function () {
            // Setup Front end editing
            if (enableFrontEndEditing) {
                root.require(['frontendediting.min'], function (frontEndEditing) {
                    frontEndEditing.setup();
                });
            }

            // Code highlighter initialization
            var $highlightedCodeElements = $('pre.HighlightedCode');
            if ($highlightedCodeElements.length > 0) {
                root.require(['prismjs/prism.min'], function () {
                    // Load css file
                    var cssId = 'prism.css';
                    if (!document.getElementById(cssId)) {
                        var head = document.getElementsByTagName('head')[0];
                        $('<link />', {
                            'id': cssId,
                            'rel': 'stylesheet',
                            'type': 'text/css',
                            'media': 'all',
                            'href': root.R + 'js/prismjs/prism.min.css'
                        }).appendTo(head);
                    }
                    root.Prism.highlightAll();
                });
            }
        });
    }
}(window, jQuery, _));